<template>
  <div id="index">
    <el-container>
      <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
        <el-main>
          <div
            aria-label="Breadcrumb"
            role="navigation"
            class="el-breadcrumb mainBread"
          >
            <span class="el-breadcrumb__item" aria-current="page"
              ><span role="link" class="el-breadcrumb__inner">IoT Insights</span
              ><i class="el-breadcrumb__separator el-icon-arrow-right"></i
            ></span>
          </div>
          <div class="KPIDiv">
            <div class="block homeCon">
              <el-row :gutter="24">
                <el-col :xs="12" :sm="12" :md="6" :lg="6">
                  <div class="LeftIcon" >
                   <i class="el-icon-set-up"></i>
                    <h4>高油滤压差</h4>
                    <span> 9 </span>
                  </div>
                </el-col>
                <el-col :xs="12" :sm="12" :md="6" :lg="6">
                  <div class="LeftIcon" >
                   <i class="el-icon-set-up"></i>
                    <h4>高进气真空</h4>
                    <span> 11 </span>
                  </div>
                </el-col>
                <el-col :xs="12" :sm="12" :md="6" :lg="6">
                  <div class="LeftIcon" >
                   <i class="el-icon-set-up"></i>
                    <h4>高油分压差</h4>
                    <span> 111 </span>
                  </div>
                </el-col>
                <el-col :xs="12" :sm="12" :md="6" :lg="6">
                  <div class="LeftIcon" >
                   <i class="el-icon-set-up"></i>
                    <h4>告警、故障的专家意见</h4>
                    <span> 0 </span>
                  </div>
                </el-col>
                <el-col :xs="12" :sm="12" :md="6" :lg="6">
                  <div class="LeftIcon" >
                   <i class="el-icon-set-up"></i>
                    <h4>频繁加卸载</h4>
                    <span> 0 </span>
                  </div>
                </el-col>
                <el-col :xs="12" :sm="12" :md="6" :lg="6">
                  <div class="LeftIcon" >
                   <i class="el-icon-set-up"></i>
                    <h4>运行时长预先通知-非易耗件</h4>
                    <span> 326 </span>
                  </div>
                </el-col>
                <el-col :xs="12" :sm="12" :md="6" :lg="6">
                  <div class="LeftIcon" >
                   <i class="el-icon-set-up"></i>
                    <h4>运行时长预先通知-易耗件</h4>
                    <span> 20 </span>
                  </div>
                </el-col>
                <el-col :xs="12" :sm="12" :md="6" :lg="6">
                  <div class="LeftIcon" >
                   <i class="el-icon-set-up"></i>
                    <h4>无油机主机高压比</h4>
                    <span> 0 </span>
                  </div>
                </el-col>
                <el-col :xs="12" :sm="12" :md="6" :lg="6">
                  <div class="LeftIcon" >
                   <i class="el-icon-set-up"></i>
                    <h4>高电机电流/高轴承温度/高绕阻温度</h4>
                    <span>0</span>
                  </div>
                </el-col>
                <el-col :xs="12" :sm="12" :md="6" :lg="6">
                  <div class="LeftIcon" >
                   <i class="el-icon-set-up"></i>
                    <h4>高主机排气温度-水冷</h4>
                    <span>0</span>
                  </div>
                </el-col>
                <el-col :xs="12" :sm="12" :md="6" :lg="6">
                  <div class="LeftIcon" >
                   <i class="el-icon-set-up"></i>
                    <h4>高主机排气温度-风冷</h4>
                    <span>0</span>
                  </div>
                </el-col>
                <el-col :xs="12" :sm="12" :md="6" :lg="6">
                  <div class="LeftIcon" >
                   <i class="el-icon-set-up"></i>
                    <h4>高电机电流/高轴承温度/高绕阻温度</h4>
                    <span>0</span>
                  </div>
                </el-col>
                <el-col :xs="12" :sm="12" :md="6" :lg="6">
                  <div class="LeftIcon" >
                   <i class="el-icon-set-up"></i>
                    <h4>低机组排气压力</h4>
                    <span>9</span>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-main>
      </el-scrollbar>
    </el-container>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
export default {
  name: "index",

  computed: {
    ...mapGetters({
      activeLang: "language",
    }),
    ...mapState({
      isCollapse: (state) => state.isCollapse,
    }),
  },
  data() {
    return {};
  },

  mounted() {},
  methods: {},
  created() {
    var _self = this;
    this.$nextTick(() => {});
  },
};
</script>


